import React from 'react';
import CandidateArchive from './CandidateArchive';

/**
 * CandidateListExpanded — Recruiter archive (thin wrapper)
 */
const CandidateListExpanded = () => <CandidateArchive mode="recruiter" />;

export default CandidateListExpanded;
